import { BRAND_CONFIG } from '@@brand'

type FormatPriceOptions = {
  locale?: string;
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  style?: 'currency' | 'decimal' | 'percent';
};

export function formatPrice (
  value: number,
  {
    locale = BRAND_CONFIG.currency.locale,
    currency = BRAND_CONFIG.currency.code,
    minimumFractionDigits = 0,
    maximumFractionDigits = 2,
    style = 'currency',
  }: FormatPriceOptions = {},
): string {
  return new Intl.NumberFormat(locale, {
    style,
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value)
}
